import { Link } from 'react-router-dom';
import { useReferences } from '../hooks/useDiscovery';

export function CategoriesIndex() {
  const { categories, loading } = useReferences();

  if (loading) {
    return (
      <div className="min-h-screen">
        <header className="bg-white border-b border-gray-200">
          <div className="container py-6">
            <div className="skeleton h-8 w-48" />
          </div>
        </header>
        <main className="container py-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
              <div key={i} className="card p-6">
                <div className="skeleton h-8 w-3/4 mb-2" />
                <div className="skeleton h-4 w-1/2" />
              </div>
            ))}
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <header className="bg-white border-b border-gray-200">
        <div className="container py-6">
          <Link to="/" className="text-sm text-gray-500 hover:text-gray-900 mb-4 inline-block">
            ← Volver a explorar
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Explorar por categoría</h1>
          <p className="mt-2 text-gray-500">
            Encuentra recomendaciones por tipo de lugar
          </p>
        </div>
      </header>

      <main className="container py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories/${cat.id}`}
              className="card p-6 hover:shadow-lg transition-shadow group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-900 group-hover:text-primary transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {cat.recommendationCount} recomendación{cat.recommendationCount !== 1 ? 'es' : ''}
              </p>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}